<footer [ngClass]="{'margin': applyMargin, 'limit-width': !applyMargin}" class="ids-h-06">
  <p class="ids-text-l ids-txt-color-sand-0">
    © {{ currentYear }} Itaú Unibanco Holding S.A. CNPJ: 60.872.504/0001-23
  </p>
  <mfe-botao-termos></mfe-botao-termos>
</footer>
